module.exports = __webpack_public_path__ + "img/usability.3adbd732.png";